module.exports = __webpack_public_path__ + "img/googlepay.5f13f49f.svg";